const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
    throw new Error(
        'REACT_APP_API_URL is missing or empty. Set REACT_APP_API_URL before starting or building.'
    );
}

export const API_URL = apiUrl;
